import React, {useMemo} from 'react'
import styled from 'styled-components'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopProfileResendVideoItemHiRes} from 'pages'
import {GiftShopResendRevisionImageItemVideoRevisedProps} from './GiftShopResendRevisionImageItemProps'

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledVersionContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${convertUnit(12)} 0;
  margin-bottom: ${convertUnit(20)};
`

export default function GiftShopResendRevisionImageItemVideoRevised({
  versionTitle,
  ...rest
}: GiftShopResendRevisionImageItemVideoRevisedProps) {
  const handleRenderTitle = useMemo(
    () => (
      <StyledVersionContainer>
        <Paragraph fontSize="m" fontWeight="medium" color="primary_5">
          {versionTitle}
        </Paragraph>
      </StyledVersionContainer>
    ),
    [versionTitle],
  )

  const handleRenderVideo = useMemo(
    () => <GiftShopProfileResendVideoItemHiRes {...rest} />,
    [rest],
  )

  return (
    <StyledColumn>
      {handleRenderTitle}
      {handleRenderVideo}
    </StyledColumn>
  )
}
